import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Status } from "../../../common/constants";
import { approveAlertUrl } from "../../../config";
import api from "../../../api";

const APPROVE_ALERT: string = "approveAlert"

interface IApproveAlertState {
    status: string,
    error: string,
    msg?:string
}
const initialState: IApproveAlertState = {
  status: Status.IDLE,
  error: null,
  msg: null,
};

export const approveAlert = createAsyncThunk(APPROVE_ALERT, async (payload: string[], { rejectWithValue }) => {
    try {
      const response = await api.put(approveAlertUrl,{subscriptionIds:payload});
      const approveAlertResponse = response.data;
      return approveAlertResponse;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);

const approveAlertSlice = createSlice({
  name: APPROVE_ALERT,
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
        builder
            .addCase(approveAlert.pending, (state) => {
                state.status = Status.PENDING;
            })
            .addCase(approveAlert.fulfilled, (state, action) => {
                state.status = Status.SUCCESS;
                state.msg = action.payload.message;
            })
            .addCase(approveAlert.rejected, (state, action) => {
                const errorPayload = action.payload as { response?: { data?: { error?: { message?: string }, message?: string } } };
                state.msg = errorPayload.response?.data?.error?.message || errorPayload.response?.data?.message || 'Unknown error occurred';
                state.status = Status.FAILED;
            });
    },
});

type Selector = {
  approveAlertApi: ReturnType<
    typeof approveAlertSlice.reducer
  >;
};

export const selector = (store: Selector) => store['approveAlertApi'];

export default approveAlertSlice.reducer;